import { render, staticRenderFns } from "./DogDigging.vue?vue&type=template&id=218f2975&"
import script from "./DogDigging.vue?vue&type=script&lang=js&"
export * from "./DogDigging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218f2975')) {
      api.createRecord('218f2975', component.options)
    } else {
      api.reload('218f2975', component.options)
    }
    module.hot.accept("./DogDigging.vue?vue&type=template&id=218f2975&", function () {
      api.rerender('218f2975', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Illustrations/DogDigging.vue"
export default component.exports